<template>
  <Transition appear mode="out-in" name="bounce-sm">
    <span :key="remaining" class="remaining flex items-center justify-center w-300 h-300 rounded-l">
      <span :class="remaining === 1 && 'last'">
        {{ remaining }}
      </span>
    </span>
  </Transition>
</template>

<script lang="ts" setup>
type Props = { remaining: number }
const { remaining } = defineProps<Props>()
</script>

<style lang="scss" scoped>
.remaining {
  background-color: token('color/background/accent/info/info');
  color: token('color/icon/primary/primary');

  .last {
    margin-left: -0.0625rem;
  }
}
</style>
